import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Report from './pages/Report';
import Rewards from './pages/Rewards';
import Newsletter from './pages/Newsletter';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Flights from './pages/Flights';
import Parking from './pages/Parking';
import ShareTrip from './pages/ShareTrip';
import ResetPassword from './pages/ResetPassword';
import './index.css';

function App() {
  return (
    <AppProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="flights" element={<Flights />} />
            <Route path="share" element={<ShareTrip />} />
            <Route path="parking" element={<Parking />} />
            <Route path="report" element={<Report />} />
            <Route path="rewards" element={<Rewards />} />
            <Route path="newsletter" element={<Newsletter />} />
            <Route path="profile" element={<Profile />} />
            <Route path="admin" element={<Admin />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </HashRouter>
    </AppProvider>
  );
}

export default App;